import styles from '../../styles/Home.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import icon from '../../public/favicon.ico';
import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import api from '../api/Apis';

const HomePage = dynamic(() => import('./Components/Home/Home'), { ssr: true });

export default function index({
  setshowloader,
  setshowminicart,
  minCartAutoshipCheck,
  smartShipCheck,
  setcounts,
  setInnerLoader,
  innerLoader,
  bannerData,
  setbannerData,
  subDomain,
  USER_DATA,
  homePageData,
}) {

  useEffect(() => {
    document.body.classList.remove('bg-salmon');
    if (setInnerLoader) {
      setInnerLoader(false);
    }
  }, [setInnerLoader]);

  return (
    <div className={homePageData === null ? 'home-all-data' : ''}>
      <HomePage
        styles={styles}
        icon={icon}
        homePageData={homePageData}
        setshowloader={setshowloader}
        smartShipCheck={smartShipCheck}
        setInnerLoader={setInnerLoader}
        setshowminicart={setshowminicart}
        minCartAutoshipCheck={minCartAutoshipCheck}
        setcounts={setcounts}
        innerLoader={innerLoader}
        subDomain={subDomain}
        USER_DATA={USER_DATA}
        bannerData={bannerData}
      />
    </div>
  );
}
export async function getStaticProps() {
  const store = 'us';

  try {
    const res = await api.getHomepageContent(store);
    const homePageData = res?.status === 200 ? res?.data : null;

    return {
      props: {
        homePageData,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error('Error fetching homepage content:', error);
    return {
      props: {
        homePageData: null,
      },
      revalidate: 60,
    };
  }
}

